import React from "react";
import BaseTooltip from "./BaseTooltip";

const isImage = (fileName = "") => /\.(png|jpe?g|webp|gif)$/i.test(fileName);

const IdentityFiles = ({ documents = [] }) => {
  if (!documents.length) return <p>-</p>;

  return (
    <div className="flex items-center gap-2">
      {documents.map((document, index) => (
        <BaseTooltip
          key={document.id}
          placement="top"
          content={
            isImage(document.fileName) && document.url ? (
              <img
                src={document.url}
                alt={document.fileName}
                className="max-w-[220px] max-h-[220px] object-contain rounded"
              />
            ) : (
              <p className="text-white">{document.fileName}</p>
            )
          }
        >
          <a
            href={document.url}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1 text-primary hover:underline"
          >
            <i className="fa-regular fa-file-lines text-base"></i>
            <span className="text-sm">{documents.length > 1 ? `File ${index + 1}` : "View"}</span>
          </a>
        </BaseTooltip>
      ))}
    </div>
  );
};

export default IdentityFiles;
